import React from 'react';
import { NavLink, Link } from 'react-router-dom';
import { FileDown, ShieldCheck, Globe } from 'lucide-react';
export function Header() {
  const navLinkClass = ({
    isActive
  }: {
    isActive: boolean;
  }) => `transition-colors relative py-2 ${isActive ? 'text-federal-blue font-black' : 'text-tech-slate hover:text-federal-blue'}`;
  const activeIndicator = ({
    isActive
  }: {
    isActive: boolean;
  }) => isActive ? <span className="absolute -bottom-1 left-0 w-full h-0.5 bg-muted-gold" data-id="element-188" /> : null;
  return <header className="sticky top-0 z-50 w-full" data-id="element-189">
      {/* Top Utility Bar */}
      <div className="bg-federal-blue text-white py-2 px-4 md:px-8 border-b border-white/10" data-id="element-190">
        <div className="max-w-7xl mx-auto flex flex-wrap justify-between items-center text-[10px] md:text-xs font-medium tracking-wider uppercase" data-id="element-191">
          <div className="flex gap-4 md:gap-8" data-id="element-192">
            <span className="flex items-center gap-1.5 opacity-90" data-id="element-193">
              <ShieldCheck className="w-3 h-3 text-muted-gold" data-id="element-194" />
              Socio-economic Status: WOSB / EDWOSB
            </span>
            <span className="flex items-center gap-1.5 opacity-90" data-id="element-195">
              <Globe className="w-3 h-3 text-muted-gold" data-id="element-196" />
              Registered: SAM.gov / UEI Ready
            </span>
          </div>
          <div className="hidden md:block opacity-70" data-id="element-197">
            CAGE: 9XYL4 | UEI: ZK82N9L1M4P7
          </div>
        </div>
      </div>

      {/* Main Navigation */}
      <nav className="bg-white border-b border-slate-200 shadow-sm" data-id="element-198">
        <div className="max-w-7xl mx-auto px-4 md:px-8 h-20 flex items-center justify-between" data-id="element-199">
          <Link to="/" className="flex items-center gap-2" data-id="element-200">
            <div className="w-12 h-10 flex items-center justify-center overflow-hidden" data-id="element-201">
              <img src="https://cdn.magicpatterns.com/uploads/qpgdNqUL4qY23U6JmdRkbZ/Codes_and_cogs_(1).png" alt="Codes & Cogs Logo" className="h-full w-auto object-contain" data-id="element-202" />
            </div>
            <div className="flex flex-col leading-tight" data-id="element-203">
              <span className="text-federal-blue font-black text-xl tracking-tighter uppercase" data-id="element-204">
                Codes & Cogs
              </span>
              <span className="text-tech-slate text-[10px] font-bold tracking-[0.2em] uppercase" data-id="element-205">
                Federal Solutions
              </span>
            </div>
          </Link>

          <div className="hidden lg:flex items-center gap-8 text-sm font-semibold text-tech-slate" data-id="element-206">
            <NavLink to="/capabilities" className={navLinkClass} data-id="element-207">
              {({
              isActive
            }) => <>
                  Capabilities
                  {activeIndicator({
                isActive
              })}
                </>}
            </NavLink>
            <NavLink to="/legacy" className={navLinkClass} data-id="element-208">
              {({
              isActive
            }) => <>
                  Our Legacy
                  {activeIndicator({
                isActive
              })}
                </>}
            </NavLink>
            <NavLink to="/locations" className={navLinkClass} data-id="element-209">
              {({
              isActive
            }) => <>
                  Locations
                  {activeIndicator({
                isActive
              })}
                </>}
            </NavLink>
            <NavLink to="/entity-data" className={navLinkClass} data-id="element-210">
              {({
              isActive
            }) => <>
                  Entity Data
                  {activeIndicator({
                isActive
              })}
                </>}
            </NavLink>
            <NavLink to="/contact" className={navLinkClass} data-id="element-211">
              {({
              isActive
            }) => <>
                  Contact Us
                  {activeIndicator({
                isActive
              })}
                </>}
            </NavLink>
          </div>

          <button className="bg-muted-gold hover:bg-[#b38f4d] text-white px-5 py-2.5 rounded-sm font-bold text-sm flex items-center gap-2 transition-all shadow-md active:scale-95" data-id="element-212">
            <FileDown className="w-4 h-4" data-id="element-213" />
            <span className="hidden sm:inline" data-id="element-214">
              Download Capability Statement
            </span>
            <span className="sm:hidden" data-id="element-215">PDF</span>
          </button>
        </div>
      </nav>
    </header>;
}